import { request } from '@/utils'

function readSetting(store, key) {
  return store.state.cms.settings[key]
}

export function installCms(Vue, store) {
  Vue.prototype.$cmsSetting = function(key, fallback = '') {
    const setting = readSetting(store, key)
    if (!setting) return fallback
    if (key.startsWith('i18n.')) return this.$i18n.locale === 'zh-CN' ? (setting.zh || setting.en || fallback) : (setting.en || setting.zh || fallback)
    return setting.value != null ? setting.value : (setting.zh != null ? setting.zh : (setting.en != null ? setting.en : fallback))
  }
  Vue.prototype.$assetUrl = function(value) {
    if (!value) return ''
    if (/^(https?:|data:|blob:)/i.test(value) || value.startsWith('/')) return value
    if (value.startsWith('legacy-logo:')) return value
    const base = this.$cmsSetting('site.asset_base_url', '/media').replace(/\/$/, '')
    return `${base}/${value.split('/').map(encodeURIComponent).join('/')}`
  }
  Vue.prototype.$cmsJson = function(key, fallback = []) {
    const value = this.$cmsSetting(key, '')
    try { return JSON.parse(value) } catch (_) { return fallback }
  }
}

export async function loadCms(store, i18n) {
  const response = await request({ url: '/public/content', method: 'get' })
  const content = response.result || {}
  store.commit('setCms', content)
  const zh = {}
  const en = {}
  Object.keys(content.settings || {}).forEach(key => {
    if (!key.startsWith('i18n.')) return
    const messageKey = key.slice(5)
    if (content.settings[key].zh != null) zh[messageKey] = content.settings[key].zh
    if (content.settings[key].en != null) en[messageKey] = content.settings[key].en
  })
  i18n.mergeLocaleMessage('zh-CN', zh)
  i18n.mergeLocaleMessage('en-US', en)
  return content
}

const logoContext = require.context('../assets/images/logos', false, /\.(png|jpe?g|gif|webp)$/i)

export function resolvePortfolioLogo(key) {
  if (!key || !key.startsWith('legacy-logo:')) return null
  const requestKey = `./${key.slice('legacy-logo:'.length)}`
  try { return logoContext(requestKey) } catch (_) { return null }
}



// WEBPACK FOOTER //
// ./src/cms/index.js